import React, { useEffect, useState } from "react";
import { ChevronDown, Eye, EyeOff, HelpCircle, Globe } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import styles from "../../styles/__login.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import InsuranceLoginImg from "../../assets/images/insuranceLogin.png";
import { postInsuranceLogin } from "../../reducer/insuranceLogin/insuranceLoginReducer";

const InsuranceLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [selectedRole, setSelectedRole] = useState("Doctor");
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [name, setName] = useState("hussan");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const countries = [
    { code: "+964", flag: "/flags/Flag_of_Iraq-64x43.png", name: "Iraq" },
    { code: "+91", flag: "/flags/Flag_of_Iraq-64x43.png", name: "India" },
    { code: "+20", flag: "/flags/Flag_of_Egypt-64x43.png", name: "Egypt" },
    {
      code: "+1",
      flag: "/flags/Flag_of_United_States-64x34.png",
      name: "United States",
    },
  ];
  const selectedCountryData =
    countries.find((country) => country.code === selectedCountry) ||
    countries[0];

  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) {
      newErrors.name = "Name is required";
    }
    // Mobile validation
    if (!mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile number is required";
    } else if (!/^\d{7,15}$/.test(mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid mobile number";
    }

    // Password validation
    if (!password.trim()) {
      newErrors.password = "Password is required";
    } else if (password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    } else if (!/[a-z]/.test(password)) {
      newErrors.password =
        "Password must include at least one lowercase letter";
    } else if (!/[A-Z]/.test(password)) {
      newErrors.password =
        "Password must include at least one uppercase letter";
    } else if (!/[0-9]/.test(password)) {
      newErrors.password = "Password must include at least one number";
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      newErrors.password =
        "Password must include at least one special character";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const passwordRules = {
    length: {
      test: (pwd) => pwd.length >= 8,
      message: "At least 8 characters",
    },
    lowercase: {
      test: (pwd) => /[a-z]/.test(pwd),
      message: "At least one lowercase letter",
    },
    uppercase: {
      test: (pwd) => /[A-Z]/.test(pwd),
      message: "At least one uppercase letter",
    },
    number: {
      test: (pwd) => /[0-9]/.test(pwd),
      message: "At least one number",
    },
    special: {
      test: (pwd) => /[!@#$%^&*(),.?\":{}|<>]/.test(pwd),
      message: "At least one special character",
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // navigate("/i_dashboard")
    if (!validateForm()) return;
    console.log("Login attempt:", {
      selectedRole,
      selectedCountry,
      mobileNumber,
      password,
    });
    const roleId = 6;
    const loginData = {
      role_id: roleId,
      mobile_number: `${selectedCountry}${mobileNumber}`,
      password: password,
    };

    const result = await dispatch(postInsuranceLogin(loginData));
    //  console.log('result:', result);
    if (result && result.payload) {
      // Save tokens
      sessionStorage.setItem("usr_1a2b3c", result.payload.data.access_token);
      sessionStorage.setItem("usr_4d5e6f", result.payload.data.refresh_token);

      // Store consultation_type if available
      if (result.payload.data.user?.consultation_type) {
        sessionStorage.setItem(
          "usr_consultation_type",
          result.payload.data.user.consultation_type,
        );
      }

      // Navigate after login
      if (
        result.payload.data.access_token &&
        result.payload.data.refresh_token
      ) {
        navigate("/i_dashboard");
      }
      // if(result.payload.data.data.verification_status === "NOT_UPLOADED" && result.payload.data.data.user.role_id === 4 ){
      //   navigate("/upload-documents");
      // }
      // else if(result.payload.data.data.verification_status === "APPROVED" && result.payload.data.data.user.role_id === 4){
      //   navigate("/dashboard")
      // }
      // else if(result.payload.data.data.verification_status === "REJECTED" && result.payload.data.data.user.role_id === 4){
      //   navigate("/upload-required-documents")
      // }
      // else if(result.payload.data.data.verification_status === "PENDING" && result.payload.data.data.user.role_id === 4){
      //   navigate("/documents-under-process")
      // }
      // else if(result.payload.data.data.verification_status === "NOT_UPLOADED" && result.payload.data.data.user.role_id === 5){
      //   navigate("/pharmacy-upload-documents")
      // }
      // else if(result.payload.data.data.verification_status === "APPROVED" && result.payload.data.data.user.role_id === 5){
      //   navigate("/pharmacy-dashboard")
      // }
      // else if(result.payload.data.data.verification_status === "REJECTED" && result.payload.data.data.user.role_id === 5){
      //   navigate("/upload-required-documents")
      // }
      // else if(result.payload.data.data.verification_status === "PENDING" && result.payload.data.data.user.role_id === 5){
      //   navigate("/documents-under-process")
      // }
    }
  };

  return (
    <div className={styles["main-container"]}>
      {/* Main Content */}
      <main className={styles["main-content"]}>
        <div className={styles["content-wrapper"]}>
          {/* Doctor Illustration */}
          <div className={styles["illustration"]}>
            <div className={styles["doctor-illustration"]}>
              <img
                src={InsuranceLoginImg}
                alt="Insurance help"
                className={styles["doctor-image"]}
              />
            </div>
          </div>

          {/* Login Form */}
          <div className={styles["login-form-container"]}>
            <h2>{t("loginToAccount")}</h2>
            <form onSubmit={handleSubmit} className={styles["login-form"]}>
              {/* Role Selection */}
              <div className={styles["form-group"]}>
                <label htmlFor={styles["role"]}>Insurance Name</label>
                <input
                  type="text"
                  id="insuranceName"
                  placeholder="GlobeMed"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={styles["form-input"]}
                />
              </div>
              {errors.name && (
                <p className={styles["rule-invalid"]}>{errors.name}</p>
              )}
              {/* Mobile Number */}
              <div className={styles["form-group"]}>
                <label htmlFor="mobile">Mobile Number</label>
                <div className={styles["mobile-input-container"]}>
                  <div className={styles["country-selector"]}>
                    <span className={styles["selected-flag"]}>
                      <img src={selectedCountryData.flag} alt="" />{" "}
                      <span>{selectedCountry}</span>
                    </span>
                    <select
                      value={selectedCountry}
                      onChange={(e) => setSelectedCountry(e.target.value)}
                      className={styles["country-dropdown"]}
                    >
                      {countries.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.code} {country.name}
                        </option>
                      ))}
                    </select>
                    <ChevronDown
                      size={14}
                      className={styles["dropdown-arrow"]}
                    />
                  </div>
                  <input
                    type="tel"
                    id="mobile"
                    placeholder="770 123 4567"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    className={styles["phone-input"]}
                  />
                </div>
                {errors.mobileNumber && (
                  <p className={styles["rule-invalid"]}>
                    {errors.mobileNumber}
                  </p>
                )}
              </div>
              {/* Password */}
              <div className={styles["form-group"]}>
                <label htmlFor="password">{t("password")}</label>
                <div className={styles["password-wrapper"]}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="••••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={styles["form-input"]}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className={styles["password-toggle"]}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                <div className={styles["password-rules"]}>
                  {Object.keys(passwordRules).map((ruleKey) => {
                    const rule = passwordRules[ruleKey];
                    const isValid = rule.test(password);
                    return (
                      <p
                        key={ruleKey}
                        className={
                          isValid
                            ? styles["rule-valid"]
                            : styles["rule-invalid"]
                        }
                      >
                        {isValid ? "✔" : "✖"} {rule.message}
                      </p>
                    );
                  })}
                </div>
                {/* <p className={styles["Forgot-pwd-link"]}><Link to="/forgot-password">{t("forgotPassword")}?</Link></p> */}
              </div>

              {/* Login Button */}
              <button type="submit" className={styles["login-btn"]}>
                {t("login")}
              </button>
            </form>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default InsuranceLogin;
